export default "__VITE_ASSET__Cflco333__"